import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Chart from '../member/Chart';

const RAILCOLOR = '#E9E9E9';

const useStyles = makeStyles(
	{
		root: {
			width: '100%',
			height: '100%',
			border: '1px solid #979797',
			padding: '24px 20px 20px 20px'
		},
		content: {
			textAlign: 'left',
			padding: 0
		},
		cardTitleText: {
			color: '#5E6366',
			fontFamily: 'Graphik',
			fontSize: 15,
			fontWeight: 600,
			letterSpacing: 0,
		},
		cardSubTitleText: {
			marginTop: 10,
			color: '#333333',
			fontFamily: 'Graphik',
			fontSize: 14,
			letterSpacing: 0,
		},
		barDiv: {
			marginTop: 35
		},
		labelText: {
			color: '#333333',
  			fontFamily: 'Graphik',
  			fontSize: 12,
  			fontWeight: 600,
  			letterSpacing: 0,
			marginTop: 35,
		}
	}
);


function makeBarOptions(value, color, tooltipDisplay) {
	return {
		chart: {
			type: 'bar',
			height: 30,
			marginLeft: 0,
			marginRight: 0,
		},
		title: {
			text: null
		},
		legend: {
			enabled: false
		},
		tooltip: {
			enabled: tooltipDisplay,
			shared: false,
			formatter: function () {
				if (this.color === RAILCOLOR) {
					return false;
				} else {
					return this.percentage;
				}
			},
			positioner: function (x, y, point) {
				return {x: point.plotX, y: point.plotY - 5}
            }
		},
		credits: {
			enabled: false
		},  
		xAxis: {
			visible: false
		},
		yAxis: {
			visible: false
		},
		plotOptions: {
			series: {
				stacking: 'normal',
				borderColor: null,
				pointWidth: 20
			}
		},
		series: [{
			color: RAILCOLOR,
			data: [100 - value]
		}, {
			color: color,
			data: [value]
		}]
	};
}

const BarGaugeCard = ( {title, subTitle, tooltipDisplay=false, bars} ) => {
	const classes = useStyles();

	return (

		<Card className={classes.root}>
			<CardContent className={classes.content}>
				<Typography className={classes.cardTitleText}>
					{title}
				</Typography>
				<Typography className={classes.cardSubTitleText}>
					{subTitle}
				</Typography>
				{bars.map((bar) => (
						<React.Fragment key={bar.label}>
							<div className={classes.barDiv}>
								<span className={classes.labelText}>{bar.label}</span>
							</div>
							<Chart options={makeBarOptions(bar.value,bar.color, tooltipDisplay)}/>
						</React.Fragment>
					))
				}
        	</CardContent>
		</Card>
	)
}

export default BarGaugeCard;